import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Force service worker update on new version
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.addEventListener("controllerchange", () => {
      // New SW activated — reload for fresh assets
      window.location.reload();
    });
  });
  // Catch SW registration failures silently
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => {
      reg.update().catch(() => {});
    });
  });
}
